import { ContentSettingsCard } from "./ContentSettingsCard";

export default ContentSettingsCard;
